import { render, staticRenderFns } from "./fail-log-card.vue?vue&type=template&id=1cfe1244&"
import script from "./fail-log-card.vue?vue&type=script&lang=js&"
export * from "./fail-log-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports